import { render, staticRenderFns } from "./pending-test-cases.vue?vue&type=template&id=10377d30&scoped=true&"
import script from "./pending-test-cases.vue?vue&type=script&lang=js&"
export * from "./pending-test-cases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10377d30",
  null
  
)

export default component.exports